'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IMAGE_EXTENSIONS = ['PNG', 'GIF', 'JPEG', 'JPG', 'SVG'];

var fileIsImage = exports.fileIsImage = function fileIsImage(file) {
  var name = file.name;

  var nameParts = name.split('.');

  var extension = nameParts[nameParts.length - 1] || '';

  return IMAGE_EXTENSIONS.indexOf(extension.toUpperCase()) !== -1;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.4519/js/attachments/fileIsImage.js
// module id = 1160
// module chunks = 2 3